/**
 * Locale is data, not code. The set is a small closed enum; each locale
 * carries its display label — the language's own autonym (English / Español /
 * Português), NOT a country flag: a flag is a nation, not a language — plus
 * the unit system it defaults to (resolved from Oxbo-M's universal
 * units-of-measure catalog in production).
 */
export type Locale = "en" | "es" | "pt-BR";

export const LOCALES: readonly Locale[] = ["en", "es", "pt-BR"] as const;

/** English is the default; US tenant reads Bakken/Williston in API units. */
export const DEFAULT_LOCALE: Locale = "en";

export type UnitSystem = "imperial" | "metric";

export interface LocaleMeta {
  id: Locale;
  /** The language's own name (autonym) — shown in the switcher. Not a flag. */
  label: string;
  defaultUnitSystem: UnitSystem;
}

export const LOCALE_META: Record<Locale, LocaleMeta> = {
  en: { id: "en", label: "English", defaultUnitSystem: "imperial" },
  es: { id: "es", label: "Español", defaultUnitSystem: "metric" },
  "pt-BR": { id: "pt-BR", label: "Português", defaultUnitSystem: "metric" },
};

export function isLocale(v: unknown): v is Locale {
  return typeof v === "string" && (LOCALES as readonly string[]).includes(v);
}
